import { request } from '../core';
import { Method } from '../core/util';

class RepairApi {
  // 获取硬件类型列表
  public getHardwareTypes = () => {
    const requestParam: RequestOptions = {
      method: Method.POST,
      path: '/k2/management/mobile/require/get_hardware_type',
    };
    return request(requestParam);
  };

  // 新增车辆维修需求
  public addVehicleRequire = (param: any) => {
    const requestParam: RequestOptions = {
      method: Method.POST,
      path: '/k2/management/mobile/require/add_vehicle_require',
      body: param,
    };
    return request(requestParam);
  };
}

export const repairApi = new RepairApi();
